import {field} from 'mc';
import {Filter} from 'mc/lib/filter';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import DateTimeField from "./DateTimeField";
import {StavVolani, LogovaniApiActions} from "@mc/poh";
import * as StavVolaniInfo from "../../api/StavVolaniInfo";

/**
 * Komponenta filtru logování API.
 */
export default class LogFilter extends PureComponent {

    static propTypes = {
        values: PropTypes.object.isRequired,
        onChange: PropTypes.func,
        sluzbaList: PropTypes.array.isRequired, // seznam existujících služeb (distinct)
    };

    constructor(props) {
        super(props);

        this.fields = [
            {
                name: 'datumCasVolaniOd',
                label: 'Datum a čas volání od',
                component: DateTimeField,
                componentProps: {
                    datePlaceholder: "Datum od",
                    timePlaceholder: "Čas od",
                }
            },
            {
                name: 'datumCasVolaniDo',
                label: 'Datum a čas volání do',
                component: DateTimeField,
                componentProps: {
                    datePlaceholder: "Datum do",
                    timePlaceholder: "Čas do",
                }
            },
            {
                name: 'sluzba',
                label: 'Služba',
                component: this.renderSluzba,
            },
            {
                name: 'stav',
                label: 'Stav',
                component: this.renderStavVolani,
            },
            {
                name: 'parametryVstup',
                label: 'Vstupní parametry',
                component: field.String,
            },
            {
                name: 'parametryVystup',
                label: 'Výstupní parametry',
                component: field.String,
            },
            {
                name: 'popisChyby',
                label: 'Popis chyby',
                component: field.String,
            },
        ];
    }

    renderSluzba = ({onChange, ...props}) => {
        const {sluzbaList} = this.props;
        return <field.Select {...props} onChange={onChange && (event => onChange(event.target.value))}>
            <option key={LogovaniApiActions.NEROZHODUJE_VALUE} value={LogovaniApiActions.NEROZHODUJE_VALUE}>
                {LogovaniApiActions.NEROZHODUJE_VALUE}
            </option>
            {sluzbaList.map(s => <option key={s} value={s}>{s}</option>)}
        </field.Select>
    };

    renderStavVolani = ({onChange, ...props}) => {
        return <field.Select {...props} onChange={onChange && (event => onChange(event.target.value))}>
            <option key={LogovaniApiActions.NEROZHODUJE_VALUE} value={LogovaniApiActions.NEROZHODUJE_VALUE}>
                {LogovaniApiActions.NEROZHODUJE_VALUE}
            </option>
            {StavVolani.values.map(s => <option key={s} value={s}>{StavVolaniInfo.getCaption(s)}</option>)}
        </field.Select>
    };

    render() {
        const {values, onChange} = this.props;
        return <Filter fields={this.fields}
                       values={values}
                       onChange={onChange}/>;
    }

}
